import { AppShowcase } from './AppShowcase';
import { Benefits } from './Benefits';
import { Features } from './Features';
import { Privacy } from './Privacy';
import { useTranslation } from 'react-i18next';
import { ScrollReveal } from './ScrollReveal';

export function FeaturesPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-teal-50">
      <section className="py-20" style={{ paddingTop: '140px' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <ScrollReveal>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              {t('nav.features')}
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={1}>
            <p className="text-xl text-gray-600">
              {t('features.subtitle')}
            </p>
          </ScrollReveal>
        </div>
      </section>
      <Features showIntro={false} />
      <AppShowcase />
      <Benefits />
      <Privacy />
    </div>
  );
}
